import React from "react";
import { Row, Col, Card, Statistic } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { Column, Pie } from "@ant-design/plots";

export default function DashboardContent() {
  const columnConfig = {
    data: [
      { country: "CHN", type: "Sales", value: 120 },
      { country: "USA", type: "Sales", value: 90 },
      { country: "UK", type: "Sales", value: 70 },
    ],
    xField: "country",
    yField: "value",
    seriesField: "type",
    color: ["#722ed1"],
  };

  const pieConfig = {
    data: [
      { type: "Search Engines", value: 30 },
      { type: "Direct Click", value: 30 },
      { type: "Bookmarks Click", value: 30 },
    ],
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    label: {
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
    },
    interactions: [{ type: "element-active" }],
  };

  return (
    <div>
      <Row gutter={16}>
        <Col span={8}>
          <Card>
            <Statistic
              title="Weekly Sales"
              value={150000}
              valueStyle={{ color: "#3f8600" }}
              prefix={<ArrowUpOutlined />}
              suffix="$"
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Weekly Orders"
              value={456334}
              valueStyle={{ color: "#cf1322" }}
              prefix={<ArrowDownOutlined />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Visitors Online"
              value={955741}
              valueStyle={{ color: "#3f8600" }}
              prefix={<ArrowUpOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 24 }}>
        <Col span={12}>
          <Card title="Visit And Sales Statistics">
            <Column {...columnConfig} />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Traffic Sources">
            <Pie {...pieConfig} />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
